import type {
  FetchSingleParameterGroupRequest,
  ParameterGroup,
  UpdateSingleParameterGroupRequest
} from 'Services/ProductManagement/Features/Parameter/types'
import { createBaseApi } from 'Util/ApiClient'
import {
  ALLOWED_TOKENS_CATEGORY,
  CUSTOMER_GROUP_CATEGORY,
  DOMICILE_CLASS_CATEGORY,
  PRODUCT_GROUP_CATEGORY,
  SALES_CHANNEL_CATEGORY
} from 'Util/constants'

export const parameterApi = createBaseApi({
  reducerPath: 'parameterApi',
  keepUnusedDataFor: 10,
  tagTypes: ['ParameterGroup']
}).injectEndpoints({
  endpoints: builder => ({
    getSingleParameterGroup: builder.query<ParameterGroup, FetchSingleParameterGroupRequest>({
      query: data => ({
        url: `/api/v1/parameter/${data.category}/`
      }),
      providesTags: result => (result ? [{ type: 'ParameterGroup', id: result.category }] : [])
    }),
    getProductGroupParameterGroup: builder.query<ParameterGroup, void>({
      query: () => ({
        url: `/api/v1/parameter/${PRODUCT_GROUP_CATEGORY}/`
      }),
      providesTags: () => [{ type: 'ParameterGroup', id: PRODUCT_GROUP_CATEGORY }]
    }),
    getAllowedTokensParameterGroup: builder.query<ParameterGroup, void>({
      query: () => ({
        url: `/api/v1/parameter/${ALLOWED_TOKENS_CATEGORY}/`
      }),
      providesTags: () => [{ type: 'ParameterGroup', id: ALLOWED_TOKENS_CATEGORY }]
    }),
    getCustomerGroupParameterGroup: builder.query<ParameterGroup, void>({
      query: () => ({
        url: `/api/v1/parameter/${CUSTOMER_GROUP_CATEGORY}/`
      }),
      providesTags: () => [{ type: 'ParameterGroup', id: CUSTOMER_GROUP_CATEGORY }]
    }),
    getSalesChannelParameterGroup: builder.query<ParameterGroup, void>({
      query: () => ({
        url: `/api/v1/parameter/${SALES_CHANNEL_CATEGORY}/`
      }),
      providesTags: () => [{ type: 'ParameterGroup', id: SALES_CHANNEL_CATEGORY }]
    }),
    getDomicileClassParameterGroup: builder.query<ParameterGroup, void>({
      query: () => ({
        url: `/api/v1/parameter/${DOMICILE_CLASS_CATEGORY}/`
      }),
      providesTags: () => [{ type: 'ParameterGroup', id: DOMICILE_CLASS_CATEGORY }]
    }),
    updateSingleParameterGroup: builder.mutation<ParameterGroup, UpdateSingleParameterGroupRequest>(
      {
        query: data => ({
          url: `/api/v1/parameter/${data.parameterGroupName}/`,
          method: 'PUT',
          body: data.payload
        }),
        invalidatesTags: result =>
          result
            ? [{ type: 'ParameterGroup', id: result.category }]
            : [
                { type: 'ParameterGroup', id: PRODUCT_GROUP_CATEGORY },
                { type: 'ParameterGroup', id: ALLOWED_TOKENS_CATEGORY },
                { type: 'ParameterGroup', id: CUSTOMER_GROUP_CATEGORY },
                { type: 'ParameterGroup', id: SALES_CHANNEL_CATEGORY },
                { type: 'ParameterGroup', id: DOMICILE_CLASS_CATEGORY }
              ]
      }
    )
  })
})

export const {
  useGetProductGroupParameterGroupQuery,
  useGetAllowedTokensParameterGroupQuery,
  useGetCustomerGroupParameterGroupQuery,
  useGetSalesChannelParameterGroupQuery,
  useGetDomicileClassParameterGroupQuery,
  useGetSingleParameterGroupQuery,
  useUpdateSingleParameterGroupMutation
} = parameterApi
